import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import { useIsBreakpoint } from "~/hooks/useIsBreakpoint";
import { useConfigContext } from "~/providers/ConfigContextProvider";
import { Heading } from "../ui/Heading";
import SideBarBlock from "./SideBarBlock";
import { primaryInput } from "detect-it";
import { IconLink } from "../ui/IconLink";
import SvgWhatsApp from "../svgs/SvgWhatsApp";
import SvgMessenger from "../svgs/SvgMessenger";
import SvgCopy from "../svgs/SvgCopy";

const Links = styled.div`
  display: flex;
  justify-items: space-between;
  flex-wrap: wrap;
  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        column-gap: ${props.theme.spacePx(
          breakpoint,
          ["base", "mobile"].includes(breakpoint) ? 7 : 8
        )};
      

        `;
    })}
`;

const SLink = styled.div`
  ${(props) =>
    props.theme.apply("default", (breakpoint: string) => {
      return `
        margin-top: ${(
          props.theme.space(breakpoint, 8) - props.theme.space(breakpoint, 9)
        ).toFixed(2)}px;
        width: ${props.theme.spacePx(
          breakpoint,
          ["base", "mobile"].includes(breakpoint) ? 6 : 7
        )};
          height: ${props.theme.spacePx(
            breakpoint,
            ["base", "mobile"].includes(breakpoint) ? 6 : 7
          )};
          
        `;
    })}
`;

export const SidebarShare = ({
  title,
  url,
}: {
  title: string;
  url: string;
}) => {
  const config = useConfigContext();
  const { isMobile } = useIsBreakpoint();
  const [parsedTitle, setParsedTitle] = useState("");
  const [isCopied, setIsCopied] = useState(false);

  useEffect(() => {
    if (typeof document === "undefined") return;
    const txt = document.createElement("textarea");
    txt.innerHTML = title;
    setParsedTitle(encodeURIComponent(txt.value));
  }, [title]);

  return (
    <SideBarBlock>
      <Heading heading="h4" space={9}>
        SHARE
      </Heading>
      <Links>
        <SLink>
          <IconLink
            type="facebook"
            url={`http://www.facebook.com/sharer.php?u=${encodeURIComponent(
              url
            )}&t=${parsedTitle}`}
            target="_blank"
            rel="nofollow noreferrer"
            title="Share on Facebook"
          />
        </SLink>

        <SLink>
          <IconLink
            type="twitter"
            url={`https://x.com/intent/tweet?text=${parsedTitle}&url=${encodeURIComponent(
              url
            )}${config.twitterHandle ? `&via=${config.twitterHandle}` : ""}`}
            target="_blank"
            rel="nofollow noreferrer"
            title="Share on Twitter"
          />
        </SLink>

        <SLink>
          <IconLink
            type="linkedin"
            url={`http://www.linkedin.com/shareArticle?mini=true&url=${encodeURIComponent(
              url
            )}&title=${parsedTitle}`}
            target="_blank"
            rel="nofollow noreferrer"
            title="Share on LinkedIn"
          />
        </SLink>
        {isMobile && primaryInput === "touch" && (
          <>
            <SLink>
              <IconLink
                svg={SvgWhatsApp}
                url={`whatsapp://send?text=${encodeURIComponent(url)}`}
                target="_blank"
                rel="nofollow noreferrer"
                title="Share on Whatsapp"
              />
            </SLink>
            <SLink>
              <IconLink
                svg={SvgMessenger}
                url={`fb-messenger://share?link=${encodeURIComponent(url)}`}
                target="_blank"
                rel="nofollow noreferrer"
                title="Share with facebook messenger"
              />
            </SLink>
          </>
        )}
        <SLink>
          <IconLink
            url="#"
            svg={SvgCopy}
            title="Copy URL to clipboard"
            rel="nofollow noreferrer"
            onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
              e.preventDefault();

              navigator.clipboard.writeText(url).then(() => {
                setIsCopied(true);
                setTimeout(() => {
                  setIsCopied(false);
                }, 750);
              });
            }}
          />
        </SLink>
      </Links>
    </SideBarBlock>
  );
};
